import React from 'react';
import { View } from 'react-native';
import Button from 'src/components/Button/Button';
import Typography from 'src/components/Text/Text';
import { styles } from '../screens/Policy/PolicyScreen.styles';

interface SwitchSectionProps<T extends string> {
  label: string; // Label text for the section
  value: T | null; // Current selected value
  onChange: (value: T) => void; // Handler for button click
  buttons: { label: string; value: T }[]; // Array of button configs
  childrenRenderCondition?: (selectedValue: T | null) => boolean; // When to render children
  children?: React.ReactNode; // Optional children components
  parentTestID?: string;
}

const SwitchSection = <T extends string>({
  label,
  value,
  onChange,
  buttons,
  childrenRenderCondition = (selectedValue) => selectedValue !== null,
  children,
  parentTestID,
}: SwitchSectionProps<T>): JSX.Element => (
  <View style={styles.field}>
    <Typography variant="h3" style={styles.label}>
      {label}
    </Typography>
    <View style={styles.switchButtonsContainer}>
      {buttons.map((button) => (
        <Button
          testID={`${parentTestID}-${button.value}`}
          key={button.value}
          title={button.label}
          type={value === button.value ? 'secondary' : 'tertiary'}
          onPress={() => onChange(button.value)}
          style={styles.switchButton}
        />
      ))}
    </View>
    {childrenRenderCondition(value) && children}
  </View>
);

export default SwitchSection;
